import * as types from "./mutation-types";

export const mutations = {
  [types.SET_POLL](state, payload) {
    state.currentPoll = payload;
  },
  [types.LIST_POLLS](state, payload) {
    state.polls = payload;
  },
  [types.SET_RESULT_COUNT](state, number) {
    state.filters.size = number;
    state.pagination.per_page = number;
    state.pagination.total = number;
    state.pagination.to = number;
  },

  [types.SET_FILTER_TOTAL](state, total) {
    state.pagination.total = total;
    state.pagination.last_page = Math.ceil(total / state.pagination.per_page);
  },

  [types.SET_CURRENT_PAGE](state, page) {
    state.pagination.current_page = page;
  },
  [types.SET_SEARCH_QUERY](state, term) {
    state.filters.searchQuery = term;
  },
  [types.SET_ENTRIES](state, entries) {
    state.entries = entries;
  },
};
